import { AbstractFacade } from '@goparrot/common';
import deepmerge from 'deepmerge';
export class FranchiseUserFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_GATEWAY,
                },
            },
            config,
        ]), interceptors);
    }
    async deleteFranchiseInvite(uuid) {
        await this.client.delete(`/api/v1/users/${uuid}/franchise-invite`);
    }
}
//# sourceMappingURL=FranchiseUserFacade.js.map